import AuthPage from './Auth'

export default AuthPage